import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "title", "description", "preview"]
  static values = {
    url: String,
  }

  async preview(event) {
    event?.preventDefault()
    if (!this.hasInputTarget || !this.hasUrlValue) return

    const url = this.inputTarget.value.trim()
    if (!url) {
      this.hidePreview()
      return
    }

    this.setPreviewContent("Fetching preview…")

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken,
          "Accept": "application/json",
        },
        body: JSON.stringify({ url }),
      })

      const payload = await response.json()
      if (!response.ok) {
        throw new Error(payload.message || "Preview not available")
      }

      this.applyPreview(payload)
    } catch (error) {
      this.setPreviewContent(error.message)
    }
  }

  applyPreview(payload) {
    if (this.hasTitleTarget && this.titleTarget.value.trim() === "" && payload.title) {
      this.titleTarget.value = payload.title
    }

    if (this.hasDescriptionTarget && this.descriptionTarget.value.trim() === "" && payload.description) {
      this.descriptionTarget.value = payload.description
    }

    const fragments = []
    if (payload.title) fragments.push(payload.title)
    if (payload.host) fragments.push(payload.host)
    if (payload.description) fragments.push(payload.description)

    this.setPreviewContent(fragments.join(" · "))
  }

  hidePreview() {
    if (!this.hasPreviewTarget) return
    this.previewTarget.hidden = true
    this.previewTarget.textContent = ""
  }

  setPreviewContent(text) {
    if (!this.hasPreviewTarget) return

    this.previewTarget.hidden = false
    this.previewTarget.textContent = text
  }

  get csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content
  }
}
